import React, { FC, useState } from 'react'

import { Modal, Txt, Icon, StandardButton } from 'src/components/atoms'
import { CompassRoleDropdown } from 'src/components/molecules'

import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'

type Props = {
  isOpen: boolean
  onClose: () => void
  changeCompassRole: (compassRoleId: number) => void
}

export const ChangeCompassRoleModal: FC<Props> = ({ isOpen, onClose, changeCompassRole }) => {
  const [selectedValue, setSelectedValue] = useState<number | undefined>()
  const { compassRoles, loading } = useGetCompassRoles()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      enabledMainContentOverflow={false}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-full-justify">
            <div className="tw-flex tw-items-center">
              <Icon
                size="--r1"
                path="user-check/soft/line"
                className="tw-accent-standardText-secondary"
              />
              <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
                権限変更
              </Txt>
            </div>
          </div>
        </div>
      }
    >
      <div className="tw-w-[32.57rem] tw-p-s2">
        <div className="tw-flex tw-items-center tw-gap-s3 tw-w-fit tw-mx-auto">
          <Txt>ROOV compass権限</Txt>
          {!loading && (
            <CompassRoleDropdown
              compassRoles={compassRoles}
              value={selectedValue}
              selectOption={setSelectedValue}
              size="m"
              className="tw-w-[17.29rem]"
            />
          )}
        </div>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            type="button"
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            size="l"
            text="決定"
            prependIconPath="check/soft/line"
            onClick={() => selectedValue && changeCompassRole(selectedValue)}
            disabled={!selectedValue}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
